import {
    apiRequest,
    bankSoalDatatable,
    bankSoalSubmit,
    bankSoalDelete,
    bankSoalActivate,
    bankSoalImport,
    bankSoalOptions,
    bankSoalCompetence
} from "../../../../../services/adapters/master/penialian360Service"

class BankSoalRepository {

    fetchCompetence = async (query) => {
        return await apiRequest("get", bankSoalCompetence, {
            params: query
        }, true)
    }

    fetchOption = async (query) => {
        return await apiRequest("get", bankSoalOptions, {
            params: query
        }, true)
    }

    fetchDataTable = async (query, cancelToken) => {
        return await apiRequest("get", bankSoalDatatable, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", bankSoalSubmit, {
            body: query
        }, true)
    }

    fetchDelete = async (query) => {
        return await apiRequest("post", bankSoalDelete, {
            body: query
        }, true)
    }

    fetchActivate = async (query) => {
        return await apiRequest("post", bankSoalActivate, {
            body: query
        }, true)
    }

    fetchImport = async (query) => {
        return await apiRequest("post", bankSoalImport, {
            body: query
        }, true)
    }

}

export default BankSoalRepository